import * as React from 'react';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import Divider from '@mui/material/Divider';
import Chip from '@mui/material/Chip';

export default function ConfigDialog(props: {
    open: boolean,
    handleClose: (groupCode: string) => void
    createNewGroup: (groupName: string) => void
}) {

  const [groupCode, setGroupCode] = React.useState('');
  const [newGroupMode, setNewGroupMode] = React.useState(false);
  const [newGroupName, setNewGroupName] = React.useState('');

  return (
    <div>
      <Dialog open={props.open} onClose={props.handleClose}>
        <DialogTitle>Social settings</DialogTitle>
        <DialogContent>
          { !newGroupMode &&
          <>
          <DialogContentText>
            To join a group and see each others habit trackers, enter the group code
          </DialogContentText>
          <TextField
            autoFocus
            margin="dense"
            id="name"
            label="Group code"
            type="text"
            value={groupCode}
            onChange={(e) => setGroupCode(e.target.value)}
            fullWidth
            variant="standard"
          />
          <Divider style={{marginTop: 25}}>
            <Chip label="Or, create a new group" onClick={() => setNewGroupMode(true)}/>
          </Divider>
          </>
          }
          { newGroupMode &&
            <>
            <DialogContentText>
            To create a group, enter a group name and remember to save it somewhere
            </DialogContentText>
            <TextField
              autoFocus
              margin="dense"
              id="name"
              label="Group name"
              type="text"
              value={newGroupName}
              onChange={(e) => setNewGroupName(e.target.value)}
              fullWidth
              variant="standard"
            />
            <Button onClick={() => props.createNewGroup(newGroupName)}
              variant="outlined" disabled={!newGroupName}>
              Generate new group code
            </Button>
            <Divider style={{marginTop: 25}}>
              <Chip label="Or, join an existing group" onClick={() => setNewGroupMode(false)}/>
            </Divider>
            </>
          }

        </DialogContent>
        <DialogActions>
          <Button onClick={() => props.handleClose('')}>Cancel</Button>
          <Button onClick={() => props.handleClose(groupCode)}>Join</Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}